var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205 215c3-3 8-3 11 0s3 7 0 10L90 351c-3 3-8 3-11 0s-3-8 0-11l126-125zm-53 125-46 46c-8 8-19 12-29 12-11 0-21-4-30-12l-27-27c-8-8-12-19-12-29 0-11 4-22 12-30l130-130c0-3-1-7-2-10l-1-9c-1-2-1-5-1-8l-1-9c0-17 4-33 10-48 7-16 16-29 28-41 11-12 25-21 41-27v-1c15-6 31-9 48-9 4 0 9 0 13 1 5 0 9 1 14 2l8 2c4 1 7 5 6 9-1 1-1 3-2 4l-57 56 6 65 65 5 56-56c3-3 8-3 10 0 1 1 2 2 2 3l3 9c1 4 1 9 2 13v13c0 18-3 34-9 49-7 15-16 29-28 41-11 11-25 21-41 27-15 6-31 10-48 10-6 0-12 0-17-1l-8-2-11-2-84 84zm-10-11 87-87c2-2 4-2 7-2l14 4 7 1c5 1 10 1 15 1 15 0 29-3 43-9 13-5 25-13 36-24 10-10 18-22 24-36 5-13 8-27 8-43v-11l-1-7-49 49c-2 1-4 2-6 2l-75-6c-4 0-6-3-7-7l-6-75c0-2 1-4 2-5l49-49-6-1c-4-1-8-1-12-1-15 0-29 3-42 8h-1c-13 6-26 14-36 25-10 10-18 22-24 35v1c-6 13-9 27-9 42l1 8v7l2 8 3 13c1 3 0 6-2 8L31 311c-5 5-8 12-8 19 0 6 3 13 8 18l27 28c5 5 12 7 19 7 6 0 13-2 18-7l47-47zm39-138c3-3 8-3 11 0s3 7 0 10L66 327c-3 3-8 3-11 0s-3-8 0-11l126-125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/Tools.3c057e14a62ebe2f8c294dd67febe3ce.svg";
export { ForwardRef as ReactComponent };